import { Div } from "@tblabs/truffle";
import { H3 } from "../../../Pages/Components/H3";
import { Paragraph } from "../../../Pages/Components/Paragraph";


export class FaqItem extends Div
{
    constructor(question: string, answer: string)
    {
        super("card faq__item");

        this.Append(
            new H3(question).Class("faq__question"),
            new Paragraph(answer).Class("faq__answer")
        );
    }
}
